import { Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { Validators, NgControl } from '@angular/forms';
import { BdsShipmentTypeService } from '@bds/data-access';
import { RtShipmentType } from '@bds/railtrac-models';
import DataSource from 'devextreme/data/data_source';
import { BdsAbstractControlValueAccessor } from '../../abstract-components/bds-abstract-control-value.accessor';
import { dxMatStyle } from '../../helpers/dx-mat-style';

@Component({
    selector: 'bds-shipment-type-select',
    template: `
        <dx-select-box
            style="margin-bottom: 0px;"
            [stylingMode]="style"
            [class.bds-mat-dense-form-field]="dense"
            [class.dx-mat-form-field-floatLabel-always]="matFloatLabel == 'always'"
            class="bds-dx-custom-material flex-fill"
            [dataSource]="dataSource"
            valueExpr="shipmentType"
            searchExpr="shipTypeDesc"
            [searchEnabled]="true"
            label="{{
                'Shipment Type' + (ngControl.control.hasValidator(validators.required) ? '*' : '')
            }}"
            [(ngModel)]="value"
            fieldTemplate="inputField"
            (onItemClick)="emitSelectionChange()"
            (onBlur)="markAsTouched()"
            [class.dx-invalid]="ngControl.control.invalid && ngControl.control.touched"
        >
            <div *dxTemplate="let data of 'item'">
                {{ getDisplayValue(data) }}
            </div>
            <div *dxTemplate="let data of 'inputField'">
                <dx-text-box
                    style="display:inline-block"
                    width="100%"
                    label="Shipment Type"
                    [value]="getDisplayValue(data)"
                ></dx-text-box>
            </div>
        </dx-select-box>
    `,
})
export class BdsShipmentTypeSelectComponent
    extends BdsAbstractControlValueAccessor<string>
    implements OnInit
{
    dataSource: DataSource;
    @Input() dense = true;
    @Input() matFloatLabel = 'always';
    @Input() matStyle: 'fill' | 'outline' | 'standard' | 'legacy' = 'fill';
    @Input() pageSize = 10;
    @Output() selectionChange = new EventEmitter();
    validators = Validators;
    constructor(
        private bdsShipmentTypeService: BdsShipmentTypeService,
        @Optional() @Self() public ngControl: NgControl,
    ) {
        super(ngControl);
    }

    get style(): string {
        return dxMatStyle(this.matStyle);
    }

    @Input() displayValue = function (data: RtShipmentType) {
        return data ? `${data.shipmentType} - ${data.shipTypeDesc}` : '';
    };

    getDisplayValue(data: RtShipmentType) {
        return this.displayValue(data);
    }

    markAsTouched() {
        if (this.ngControl?.control) {
            this.ngControl.control.markAsTouched();
        }
    }

    getError(): string {
        if (this.ngControl && this.ngControl.errors) {
            if (this.ngControl.errors['required']) {
                return 'Required';
            }
        }
        return '';
    }

    emitSelectionChange() {
        this.selectionChange.emit();
    }

    ngOnInit() {
        this.dataSource = new DataSource({
            store: this.bdsShipmentTypeService.getODataStore(),
            paginate: true,
            pageSize: this.pageSize,
        });
    }
}
